import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'

/** 兜底背景的css变量 */
export abstract class _FallbackBackgroundBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'larger'
  constructor() {
    super()
    this['--fallback-background-z-index'] = '-1'
    this['--fallback-background-border-radius'] = '0'
    this['--fallback-background-image'] = 'initial'
    this['--fallback-background-color'] = 'var(--theme-game-card-ddt_bg)'
  }
  /** 背景图字号(尺寸,字体图标) */
  ['--fallback-background-font-size']?: string;
  /** 背景图层级*/
  ['--fallback-background-z-index']?: string;
  /** 圆角弧度 */
  ['--fallback-background-border-radius']?: string;
  /** 在没有背景图的时候兜底div背景图(渐变色) */
  ['--fallback-background-image']?: string;
  /** 在没有背景图的时候兜底div颜色 */
  ['--fallback-background-color']?: string
}

/** 兜底背景图变量 */
export type _FallbackBackgroundCssVar =
  GetCssVarManager<_FallbackBackgroundBase>
